import {announce} from '@react-aria/live-announcer'
import {toast} from 'sonner'

import getAccountInformation from '@/auth/utils/getAccountInformation'
import {GoogleSignInRoute} from '@/routeRegistry'
import {signInWithGoogle} from '@/services/authenticationService'
import shouldLogError from '@/utils/api/shouldLogError'
import toastErrorMessage from '@/utils/errors/toastErrorMessage'
import {logError} from '@/utils/logger'

const ERROR_MESSAGE =
  'Something went wrong while trying to login with Google. Please try again. If the problem persists, please contact support.'

export default function SignInWithGoogle() {
  const router = useRouter()
  const {referrerId, redirect} = GoogleSignInRoute.useSearch()
  const {idToken} = GoogleSignInRoute.useParams()

  useEffect(() => {
    void signInWithGoogle({token: idToken, referrerId})
      .then(() => {
        // We have to use `getAccountInformation` because the account is not available in the store yet
        const account = getAccountInformation()

        if (!account) {
          throw new Error('Failed to get account information')
        }

        toast.success(`Logged in as ${account.accountName} (${account.email})`)
        announce(`Logged in as ${account.accountName} (${account.email})`)
      })
      .catch(e => {
        if (shouldLogError(e)) {
          logError(e)
        }
        toastErrorMessage(ERROR_MESSAGE)
      })
      .finally(() => {
        void router.navigate({to: redirect})
      })
  }, [idToken, referrerId, redirect, router])

  return null
}
